import { render, staticRenderFns } from "./DuplicateWidgetForm.vue?vue&type=template&id=9ecb6070&scoped=true"
import script from "./DuplicateWidgetForm.vue?vue&type=script&lang=js"
export * from "./DuplicateWidgetForm.vue?vue&type=script&lang=js"
import style0 from "./DuplicateWidgetForm.vue?vue&type=style&index=0&id=9ecb6070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb6070",
  null
  
)

export default component.exports